import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Modal, Paragraph, Anchor, Heading, List, TriggerText } from "@zillow/constellation-10";
import "react";
const MortgageRatesTableModal = ({
  updatedAt,
  loanToValueBucket,
  creditScoreBucket,
  rates,
  refinance
}) => {
  let loanToValueBucketLabel = "80";
  let creditScoreBucketLabel = "740";
  switch (loanToValueBucket) {
    case "Normal":
      loanToValueBucketLabel = "80%";
      break;
    case "High":
      loanToValueBucketLabel = "95%";
      break;
    case "VeryHigh":
      loanToValueBucketLabel = "100%";
      break;
  }
  switch (creditScoreBucket) {
    case "Low":
      creditScoreBucketLabel = "680";
      break;
    case "High":
      creditScoreBucketLabel = "740";
      break;
    case "VeryHigh":
      creditScoreBucketLabel = "740+";
      break;
  }
  return /* @__PURE__ */ jsx(Modal, { size: "md", trigger: /* @__PURE__ */ jsx(TriggerText, { children: "See legal disclosures." }), header: /* @__PURE__ */ jsx(Heading, { level: 6, css: {
    textAlign: "center"
  }, children: "Legal Disclosures" }), body: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Paragraph, { css: {
      marginBottom: "loose"
    }, children: [
      "Representative rates are based upon national or state specific averages from lenders quoting on Zillow for preliminary research purposes only. Actual available rates and monthly payment amounts are subject to market fluctuations and will depend on a number of factors, including geography and loan characteristics. Representative rates are valid as of ",
      updatedAt,
      " and assume a minimum credit score of",
      " ",
      creditScoreBucketLabel,
      " and loan-to-value ratio of",
      " ",
      loanToValueBucketLabel,
      ", except for FHA and VA loans which assume a minimum credit score of 680-739 and loan-to-value ratio of 96.5% and 100%, respectively. The Jumbo loan amount shown exceeds the highest conforming loan limit in most state or city locations for which rates are being provided. Currently, a Jumbo loan exceeds $726,200 for a single-family home in all states (except Hawaii and Alaska, and a few federally designated markets where the limit is $1,089,300). Estimated monthly payment amounts displayed are based upon principal and interest only, and taxes and insurance are not included in this estimate; the actual payment obligation may be greater. Not all borrowers will qualify for these rates. Final loan approval is subject to criteria established by a lender, including satisfactory appraisal, title review, and underwriting determination, among other criteria. Rates subject to change without notice. Restrictions apply.",
      " ",
      /* @__PURE__ */ jsx(Anchor, { href: "https://www.zillow.com/mortgage-rates/#LegalDisclosuresModal_rate_details", children: "Click here to learn more details about the rates displayed." })
    ] }),
    /* @__PURE__ */ jsx(Paragraph, { css: {
      marginBottom: "loose"
    }, children: "NOTE: Mortgage rate trends are based on historical rate data and the inputs that you select. Changes to inputs will affect the rate trends shown. Mortgage rate trends displayed are for informational purposes only and represent rate trends over time and are based upon national or state specific averages from lenders quoting on Zillow for preliminary research purposes only." }),
    /* @__PURE__ */ jsx(Paragraph, { css: {
      marginBottom: "loose"
    }, children: "Mortgage rates are displayed through Zillow Group Marketplace, Inc. (“ZGMI”) a licensed mortgage broker, NMLS #1303160. Zillow Group Marketplace, Inc. does not make loans and this is not a commitment to lend. See current list of state licenses and disclosures here. Please note: Adjustable-rate mortgages (ARMs) are loans with interest rates that change after an initial fixed-rate period." }),
    /* @__PURE__ */ jsx(Paragraph, { css: {
      marginBottom: "loose"
    }, children: "ZGMI does not aid or assist consumers in obtaining loans, solicit consumers or lenders for loans, offer or negotiate terms of loans, make loans or credit decisions in connection with loans, take applications for credit, or issue pre-approval letters. ZGMI allows consumers to provide certain information to lenders. ZGMI does not guarantee that the loan terms or rates offered and made available by lenders are the best terms or lowest rates available in the market." }),
    /* @__PURE__ */ jsx(Heading, { level: 6, css: {
      marginTop: "loose"
    }, children: "More details about the rates displayed" }),
    /* @__PURE__ */ jsx(List.Root, { children: (rates == null ? void 0 : rates.length) > 0 && rates.map((rate, index) => {
      var _a, _b, _c;
      const refinanceText = !refinance ? `with a $${(_a = rate == null ? void 0 : rate.downPayment) == null ? void 0 : _a.toLocaleString("en-US")} down payment ` : "";
      return /* @__PURE__ */ jsxs(List.Item, { children: [
        "A ",
        rate == null ? void 0 : rate.program,
        " loan of $",
        (_b = rate == null ? void 0 : rate.loanAmount) == null ? void 0 : _b.toLocaleString("en-US"),
        " ",
        "at ",
        rate == null ? void 0 : rate.apr,
        "% APR ",
        refinanceText,
        " will have a monthly payment of $",
        (_c = rate == null ? void 0 : rate.monthlyPayment) == null ? void 0 : _c.toLocaleString("en-US")
      ] }, index);
    }) })
  ] }) });
};
export {
  MortgageRatesTableModal as default
};
